export const CACHE_CONFIG = {
  PRODUCTS: {
    key: 'jowey_products_cache',
    timestampKey: 'jowey_products_timestamp',
    duration: 5 * 60 * 1000,
    maxAge: 30 * 60 * 1000,
  },
  BLOGS: {
    key: 'jowey_blogs_cache',
    timestampKey: 'jowey_blogs_timestamp',
    duration: 10 * 60 * 1000,
    maxAge: 60 * 60 * 1000,
  },
};

class EnhancedCache {
  constructor() {
    this.storage = window.localStorage;
  }

  set(config, data) {
    try {
      this.storage.setItem(config.key, JSON.stringify(data));
      this.storage.setItem(config.timestampKey, Date.now().toString());
      return true;
    } catch {
      return false;
    }
  }

  get(config) {
    try {
      const data = this.storage.getItem(config.key);
      const timestamp = this.storage.getItem(config.timestampKey);
      if (!data || !timestamp) return null;

      const age = Date.now() - parseInt(timestamp, 10);
      if (age > config.maxAge) {
        this.clear(config);
        return null;
      }

      return {
        data: JSON.parse(data),
        isStale: age > config.duration,
        age,
      };
    } catch {
      this.clear(config);
      return null;
    }
  }

  clear(config) {
    this.storage.removeItem(config.key);
    this.storage.removeItem(config.timestampKey);
  }

  clearAll() {
    Object.keys(this.storage).forEach((key) => {
      if (key.startsWith('jowey_')) this.storage.removeItem(key);
    });
  }

  getStats() {
    const stats = { totalEntries: 0, totalSize: 0, caches: {} };
    Object.keys(CACHE_CONFIG).forEach((name) => {
      const cached = this.get(CACHE_CONFIG[name]);
      if (cached) {
        const size = JSON.stringify(cached.data).length;
        stats.totalEntries += 1;
        stats.totalSize += size;
        stats.caches[name] = { size, age: cached.age, stale: cached.isStale };
      }
    });
    return stats;
  }
}

export class WhatsAppUtils {
  static formatPrice(price) {
    return 'KES ' + Number(price).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  static formatProductMessage(product) {
    const imageUrl = product.image_url || product.imageUrl;
    return `Hi! I'm interested in this product:

${product.name}
${product.description}
Price: ${this.formatPrice(product.price)}

${imageUrl ? `Product Image: ${imageUrl}` : ''}

Could you please provide more information about this item? Thank you!`;
  }

  static openWhatsApp(product, phoneNumber = '254702405954') {
    const message = encodeURIComponent(this.formatProductMessage(product));
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  }
}

export const cache = new EnhancedCache();
export const whatsapp = WhatsAppUtils;

export function formatKES(amount) {
  return WhatsAppUtils.formatPrice(amount);
}
